export default __webpack_public_path__ + "static/media/admin-login-banner.cb663e6c.jpg";